import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface PublicRouteProps {
  children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  console.log('PublicRoute - Loading:', loading, 'Authenticated:', isAuthenticated);

  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  
  if (isAuthenticated) {
    console.log('PublicRoute - User already authenticated, redirecting to home');
    return <Navigate to="/" replace />;
  }
  
  console.log('PublicRoute - User not authenticated, showing login page');
  return <>{children}</>;
};

export default PublicRoute;
